// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"3494a1f0","25":"a8186327","41":"428b3c79","390":"2384ec32","578":"3d8a55be","584":"21296e73","618":"6cca0056"}[chunkId] + ".chunk.js";
};